import React, {  lazy, Component } from 'react';
import { Row} from 'react-bootstrap';
import { connect } from "react-redux";
// import OnImagesLoaded from 'react-on-images-loaded';
// import homePageHorizontal from '../assets/main/homePageHorizontal.jpg'

// import homePageVertical from "../assets/galleries/quindio/Quindio23.jpg"


// import  { useState,useEffect } from 'react';
// import arequipaSquare from '../assets/main/arequipaSquare.jpg'
// import huacachinaSquare from '../assets/main/huacachinaSquare.jpg'
// import sacredValleysquare from '../assets/main/sacredValleysquare.jpg'
// import cuscoSquare from '../assets/main/cuscoSquare.jpg'
// import otavaloSquare from '../assets/main/otavaloSquare.jpg'
// import huarazSquare from '../assets/main/huarazSquare.jpg'

import { LazyLoadImage } from "react-lazy-load-image-component";
import 'react-lazy-load-image-component/src/effects/blur.css';

import {loadUser} from "../store/actions/creators/user"

const BannerNotification = lazy(()=>import('./bannerNotification'))

const LoginPrompt = lazy(() => import('./sharedComponents/loginPrompt'));
const LogoutPrompt = lazy(() => import('./sharedComponents/logoutPrompt'));
// const HuarazSquare = lazy(() => import('../assets/main/huarazSquare.jpg'));
const DesktopHeader = lazy(() => import('./sharedComponents/navComponents/desktopHeader'));
const MobileHeader = lazy(() => import('./sharedComponents/navComponents/mobileHeader'));
// const LoadScreen = lazy(()=> import('./sharedComponents/loadScreen'))
const AboutPreview = lazy(() => import('./sharedComponents/previewComponents/aboutPreview'));
const BlogPreview = lazy(() => import('./sharedComponents/previewComponents/blogPreview'));
const LinksPreview = lazy(() => import('./sharedComponents/previewComponents/linksPreview'));
const GalleryPreview = lazy(() => import('./sharedComponents/previewComponents/galleryPreview'));
const Footer = lazy(() => import('./sharedComponents/footer'));

const arequipaSquare ="https://res.cloudinary.com/busy-bee/image/upload/v1670858572/Other/arequipaSquare_th3xcx.jpg"
const huacachinaSquare ="https://res.cloudinary.com/busy-bee/image/upload/v1670858570/Other/huacachinaSquare_sc2q86.jpg"
const sacredValleysquare="https://res.cloudinary.com/busy-bee/image/upload/v1670858571/Other/sacredValleysquare_ukhlft.jpg"
const cuscoSquare="https://res.cloudinary.com/busy-bee/image/upload/v1670858574/Other/cuscoSquare_mpu7ru.jpg"
const otavaloSquare="https://res.cloudinary.com/busy-bee/image/upload/v1670858571/Other/otavaloSquare_gy3wj6.jpg"
const huarazSquare="https://res.cloudinary.com/busy-bee/image/upload/v1670858570/Other/huarazSquare_knubq0.jpg"

const arequipaSquareLC ="https://res.cloudinary.com/busy-bee/image/upload/v1670858683/Other/Low%20Quality/arequipaSquare_di56ve.jpg"
const huacachinaSquareLC ="https://res.cloudinary.com/busy-bee/image/upload/v1670858683/Other/Low%20Quality/huacachinaSquare_xloimv.jpg"
const sacredValleysquareLC ="https://res.cloudinary.com/busy-bee/image/upload/v1670858683/Other/Low%20Quality/sacredValleysquare_y4hiwy.jpg"
const cuscoSquareLC ="https://res.cloudinary.com/busy-bee/image/upload/v1670858683/Other/Low%20Quality/cuscoSquare_kbgi9w.jpg"
const otavaloSquareLC ="https://res.cloudinary.com/busy-bee/image/upload/v1670858683/Other/Low%20Quality/otavaloSquare_qmozzs.jpg"
const huarazSquareLC ="https://res.cloudinary.com/busy-bee/image/upload/v1670858683/Other/Low%20Quality/huarazSquare_bfjoua.jpg"

const homePageHorizontal ="https://res.cloudinary.com/busy-bee/image/upload/v1670858574/Other/homePageHorizontal_bvvslf.jpg"
const homePageVertical ="https://res.cloudinary.com/busy-bee/image/upload/v1669034556/Galleries/Quindio/Quindio23_oxkxqk.jpg"
const homePageHorizontalLC ="https://res.cloudinary.com/busy-bee/image/upload/v1670858683/Other/Low%20Quality/homePageHorizontal_frkaw8.jpg"
const homePageVerticalLC ="https://res.cloudinary.com/busy-bee/image/upload/v1670536437/Galleries/Quindio/Low%20Qual/Quindio23_xcjsoe.jpg"

class Main extends Component {
  // Setting up initial state
  constructor(props) {
    super(props);
    this.state = {
      isMobile:false,
      isLoaded:false,
      imagesLoaded:false,
      showOutcomeMessage:false,
      galleryPreviews:[
        {name:'Huaraz',
         pic:huarazSquare,
         placeholder:huarazSquareLC,
         tags:['activity', 'bc','','','','','','','',''],
         link:'/Huaraz',
         key:'1'},
        {name:'Huacachina',
         pic:huacachinaSquare,
         placeholder:huacachinaSquareLC,
         tags:['activity', 'bc','','','','','','','',''],
         link:'/Huacachina',
         key:'2'},
         {name:'Arequipa',
          pic: arequipaSquare,
          placeholder:arequipaSquareLC,
          tags:['activity', 'bc','','','','','','','',''],
          link:'/Arequipa',
          key:'3'},
          {name:'Sacred Valley',
           pic:sacredValleysquare,
           placeholder:sacredValleysquareLC,
           tags:['activity', 'bc','','','','','','','',''],
           link:'/SacredValley',
           key:'4'},
           {name:'Cusco',
            pic:cuscoSquare,
            placeholder:cuscoSquareLC,
            tags:['activity', 'bc','','','','','','','',''],
            link:'/Cusco',
            key:'5'},
        {name:'Otavalo',
         pic:otavaloSquare,
         placeholder:otavaloSquareLC,
         tags:['activity', 'bc','','','','','','','',''],
         link:'/Otavalo',
         key:'6'},

      ]


    };
    this.updateDimensions = this.updateDimensions.bind(this);

  };
  componentDidMount(){
    window.addEventListener('resize', this.updateDimensions);
    window.addEventListener("contextmenu", e => e.preventDefault());
    setTimeout(() => {
      this.updateDimensions();
    }, 100)

    if (this.props.auth.isAuthenticated) {
      this.props.dispatch(loadUser(this.props.auth.isAuthenticated))
    }
  }
  componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
  }
  updateDimensions() {
    let windowWidth = typeof window !== "undefined" ? window.innerWidth : 0;
    let windowHeight = typeof window !== "undefined" ? window.innerHeight : 0;
    if (windowWidth>= windowHeight) {
      if (this.state.isMobile) {
        this.setState({isMobile:false});
      }
    }
    else {
      if (!this.state.isMobile) {
        this.setState({isMobile:true});
      }
    }
  }




  render() {

  return(
    <>


        <div style ={{overflowX:'hidden'}}>
          <BannerNotification notification={this.props.notifications}/>
          <HomePage galleryPreviews={this.state.galleryPreviews}
                    isMobile={this.state.isMobile}
                    isAuthenticated={this.props.auth.isAuthenticated}
                    userEmail={this.props.user.user.email}
                    />
        </div>



    </>
)}};
const mapStateToProps = (state) => {
  return{auth:state.auth,
         notifications:state.notifications,
         user:state.user}
};

export default connect(mapStateToProps)(Main);

const HomePage = props => {


return(
  <>
    
    {props.isMobile?
      <>
        <MobileHeader />
        <Row style ={{pading:'0vh'}}>
          <LazyLoadImage 
                  src= {homePageVertical}
                  placeholderSrc={homePageVerticalLC}
                  style={{
                          padding:'0vh',
                          marginLeft:'0vw',
                          minWidth:'100vw',
                          fontSize: '0px',
                          width:"100vw"}}    
                  alt={'Couple Holding Hands At Cocora Valley'}
                  className ='banner-pic'  />
          
        </Row>
      </>
      :
      <>
    
        <LoginPrompt isAuthenticated={props.isAuthenticated}/>
        <LogoutPrompt isAuthenticated={props.isAuthenticated}
                      userEmail={props.userEmail}/>
        <DesktopHeader componentReady={props.componentReady}/>
        <Row style ={{pading:'0vh',fontSize:'0vh'}}>
        <LazyLoadImage 
                  src= {homePageHorizontal}
                  placeholderSrc={homePageHorizontalLC} 
                  effect="blur"
                  alt={'Couple Holding Hands At Cocora Valley'} 
                  className ='banner-pic'  />
        </Row>
    
      </>}

    <AboutPreview componentReady={props.componentReady}/>
    <LinksPreview useLink={props.useLink}
                  componentReady={props.componentReady}/>
    <GalleryPreview galleryImages={props.galleryPreviews}
                    componentReady={props.componentReady}/>
    <BlogPreview componentReady={props.componentReady}/>

    <Footer isMobile={props.isMobile}/>

  </>
)
}
